import { Box, useTheme } from "@mui/material";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import OrdersTable from "../DataGrid/OrdersTable";

const Team = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  return (
    <Box m="20px">
      <Header title="Order Registration" subtitle="Manage The Order Registration" />
      <OrdersTable />
    </Box>
  );
};

export default Team;
